import aspirantPageImagePaths from '@/constants/ImagePaths/Aspirants/aspirantPageImagePaths';
import businessPageImagePaths from '@/constants/ImagePaths/Business/businessPageImagePaths';

export const heroSectionData = {
  heading: {
    primary: 'Empowering Talent.',
    secondary: 'Enabling Growth.',
    primaryColor: '#A62973',
    secondaryColor: '#A62973',
  },
  description: 'A dynamic ecosystem where talent and opportunities converge',
  buttonContent: 'Ask for Demo',
  bannerImage: businessPageImagePaths.heroSection.banner,
  secondaryButton: {
    text: 'Learn More',
    href: '/articles/razorswift-transforming-talent-recruitment-and-management-with-generative-ai/',
  },
};

export const businessDropDownBodyData = {
  id: 1,
  title: 'Experience Swift',
  highLightedTitle: 'Hiring.',
  backgroundColor: '#DCA9C7',
  buttonData: {
    title: 'Ask for Demo',
    backgroundColor: '#FFFFFF',
    color: '#A62973',
    link: '/contact-us?from=business',
  },
  trophyImage: businessPageImagePaths.dropDownSection.clock,
  description: 'Intelligent hiring automation with Generative AI',
  image: businessPageImagePaths.dropDownSection.business,
  whatToExpect: [
    {
      id: 1,
      image: businessPageImagePaths.dropDownSectionOne.forStudents.icon1,
      title: 'Job ready talent on Day 1',
      description:
        'Manage skill gap and talent shortage with customized pathways.',
    },
    {
      id: 2,
      image: businessPageImagePaths.dropDownSectionOne.forStudents.icon2,
      title: 'Unified talent ecosystem',
      description: 'Seamless collaboration with talent partners with pathways.',
    },
    {
      id: 3,
      image: businessPageImagePaths.dropDownSectionOne.forStudents.icon3,
      title: 'Standardized profiles',
      description:
        'AI enriched candidate profiles for data driven decision making.',
    },
    {
      id: 4,
      image: businessPageImagePaths.dropDownSectionOne.forStudents.icon4,
      title: 'Be a Marquee employer',
      description:
        'Enhanced exposure and increased recognition among aspirants with corporate pathways.',
    },
  ],
};

export const whyRazorswiftSection = {
  title: 'WHY RAZORSWIFT',
  description:
    "We are an innovative digital marketplace that leverages AI and a comprehensive knowledge partner ecosystem to empower aspiring individuals and streamline talent acquisition for businesses in India. Through our unique 'Pathways' approach, we offer tailored journeys for individuals to excel within the evolving hiring landscape, while also providing businesses with structured processes for aligning competencies and efficient curation.",

  button: { title: 'Explore', link: '/' },
  cardsRight: [
    {
      id: 1,
      percentage: '70%',
      bgColor: '#EBC8DD',
      description: 'Faster onboarding process',
    },
    {
      id: 2,
      percentage: '90%',
      bgColor: '#FFE3E3',
      description: 'Improvement in best candidate matches',
    },
  ],

  cardsLeft: [
    {
      id: 1,
      percentage: '70%',
      bgColor: '#FFCCC9',
      description: 'Improvement in new hire retention',
    },
    {
      id: 2,
      percentage: '70%',
      bgColor: '#EDD8F2',
      description: 'Reduction and removing human bias',
    },
  ],
};

export const readyToStartData = {
  title: 'READY TO GET STARTED?',
  description: 'Hire at scale with the click of a button',
  mainImage: businessPageImagePaths.readyToGetStarted.mainImage,
  buttonUrl: '/contact-us?from=business',
  buttonText: 'Get a Demo',
};

export const quickTalentDiscoveryData = {
  mainTitle: 'Razorswift PATHWAYS - QUICK TALENT DISCOVERY',
  mainDescription:
    'Pathways allow you to standardize assessments and training, to gain access to a large pool of verified profiles that match your unique requirement.',
  pathways: [
    {
      id: 1,
      title: 'Company crafted pathways',
      description:
        'Tailor make your pathway to get interested aspirants to self curate their competencies to align with your skill requirements and cultural fit.',
      backgroundColor: '#FFE1E1',
      image: businessPageImagePaths.pathwayIcons.icon1,
      mainImage: businessPageImagePaths.dropDownSection.mainImage1,
    },
    {
      id: 2,
      title: 'ROI driven efficiency',
      description:
        'Leverage AI and data insights along with third party integrations for unparalleled cost and time efficiency.',
      backgroundColor: '#E5BED5',
      image: businessPageImagePaths.pathwayIcons.icon2,
      mainImage: businessPageImagePaths.dropDownSection.mainImage2,
    },
    {
      id: 3,
      title: 'Seamless eco-sysem integration',
      description:
        'Connect with tools and platforms of choice and custom create an integrated solution on RazorSwift.',
      backgroundColor: '#DCBDE3',
      image: businessPageImagePaths.pathwayIcons.icon3,
      mainImage: businessPageImagePaths.dropDownSection.mainImage3,
    },
    {
      id: 4,
      title: 'Actionable data insights',
      description:
        'Gain a wealth of data on aspirants leading to informed decisions to re-configure the pathway as needed.',
      backgroundColor: '#FCC9CF',
      image: businessPageImagePaths.pathwayIcons.icon4,
      mainImage: businessPageImagePaths.dropDownSection.mainImage4,
    },
  ],
};

export const TickerBoxData = {
  tickerArrow: aspirantPageImagePaths.tickerSection.arrow,
  slidingValue: [
    {
      id: 1,
      title: 'Schedule a demo with us',
      link: '/contact-us',
    },
    {
      id: 2,
      title: 'Hire at scale with a click of a button. Start now',
      link: '/contact-us',
    },
    {
      id: 3,
      title: 'Learn more about RazorSwift Pathways - coming soon',
      link: '/contact-us',
    },
    {
      id: 4,
      title: 'Craft your customized pathway now',
      link: '/contact-us',
    },
  ],
};

export const BusinessAdvantagesData = {
  title: 'Razorswift ADVANTAGES FOR BUSINESSES',
  contents: [
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon1,
      title: 'AI Driven Enhanced Candidate Profile',
      description:
        'For profile standardization and high quality data driven decision making. Helps in comparing apples with apples.',
    },
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon2,
      title: 'Seamless Integration',
      description:
        'Plug-and-play solutions that enhance existing hiring systems and eco-system partners on one platform reducing Total Cost of Ownership and providing significant cost savings.',
    },
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon3,
      title: 'AI-Driven Insights',
      description:
        'Providing deep, data-driven intelligence for better hiring decisions negating human bias/fatigue in the hiring process and significantly improving efficiency.',
    },
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon4,
      title: 'Customisable Scoring',
      description:
        'Tailoring evaluation criteria to meet unique requirements with generative AI. Helps in ranking profiles in the order of merit.',
    },
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon6,
      title: 'Comprehensive Skill Reflection',
      description: 'Highlighting relevant and current skill sets.',
    },
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon5,
      title: 'Integrated Social validation',
      description: 'For skill verification and endorsements.',
    },
    {
      image: businessPageImagePaths.BusinessAdvantagesData.icon7,
      title: 'Single Management Dashboard',
      description:
        'Enabling clients to monitor and manage candidate progression as the navigate through the hiring process.',
    },
    {
      cta: true,
    },
  ],
};
